export default {
  addTaxDetails: {
    id: 'bo_seller_profile_page_tax_details_add_tax_details',
    defaultMessage: 'Add tax details',
  },
  edit: {
    id: 'bo_seller_profile_page_tax_details_edit',
    defaultMessage: 'Edit tax details',
  },
  euSellersAction: {
    id: 'bo_seller_profile_page_tax_details_eu_sellers_action',
    defaultMessage: 'For EU sellers: VAT information',
  },
  shippingFrom: {
    id: 'bo_seller_profile_page_shipping_from',
    defaultMessage: 'Shipping from',
  },
  fetchErrorTitle: {
    id: 'bo_seller_profile_page_fetch_error_title',
    defaultMessage: 'Oops!',
  },
  fetchVatInformationsErrorMessage: {
    id: 'bo_seller_profile_page_fetch_vat_informations_error_message',
    defaultMessage: 'Something went wrong while fetching your VAT information.',
  },
  fetchOssDocumentsErrorMessage: {
    id: 'bo_seller_profile_page_fetch_os_documents_error_message',
    defaultMessage: 'Something went wrong while fetching your OSS documents.',
  },
  intracommunityVatNumberLabel: {
    id: 'bo_seller_profile_page_tax_details_intra_community_vat_number_label',
    defaultMessage: 'Intra-community VAT number',
  },
  isExemptFromVatLabel: {
    id: 'bo_seller_profile_page_tax_details_block_is_exempt_vat_label',
    defaultMessage: 'Small business exempt from VAT?',
  },
  yes: {
    id: 'bo_seller_profile_page_tax_details_block_yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'bo_seller_profile_page_tax_details_block_no',
    defaultMessage: 'No',
  },
  legalAreaEuFormattedValue: {
    id: 'bo_seller_profile_page_tax_details_eu_formatted_value',
    defaultMessage: 'European Union',
  },
  legalAreaLabel: {
    id: 'bo_seller_profile_page_tax_details_legal_area_label',
    defaultMessage: 'Business’s legal country of residence',
  },
  legalAreaNotEuFormattedValue: {
    id: 'bo_seller_profile_page_tax_details_not_eu_formatted_value',
    defaultMessage: 'Non-EU country',
  },
  marginVatFormattedValue: {
    id: 'bo_seller_profile_page_tax_details_margin_vat_formatted_value',
    defaultMessage: '100% margin VAT',
  },
  mixedVatFormattedValue: {
    id: 'bo_seller_profile_page_tax_details_mixed_vat_formatted_value',
    defaultMessage: 'Mixed VAT',
  },
  normalVatFormattedValue: {
    id: 'bo_seller_profile_page_tax_details_normal_vat_formatted_value',
    defaultMessage: '100% normal VAT',
  },
  notEuSellersAction: {
    id: 'bo_seller_profile_page_tax_details_not_eu_sellers_action',
    defaultMessage: 'For US and non UE sellers: tax number',
  },
  onboardedInfoBlockContent: {
    id: 'bo_seller_profile_page_tax_details_onboarded_info_block_content',
    defaultMessage:
      'We updated this section and need you to review your existing information.',
  },
  onboardedInfoBlockTitle: {
    id: 'bo_seller_profile_page_tax_details_onboarded_info_block_title',
    defaultMessage: 'Got a sec to look over this?',
  },
  ossRegistrationLabel: {
    id: 'bo_seller_profile_page_tax_details_oss_registration_label',
    defaultMessage: 'Oss-registered?',
  },
  taxDetailsEmptyStateHeader: {
    id: 'bo_seller_profile_page_tax_details_tab_description',
    defaultMessage: "Here's what you need to do",
  },
  taxIdNumberLabel: {
    id: 'bo_seller_profile_page_tax_details_intra_community_tax_id_number_label',
    defaultMessage: 'VAT, TIN/EIN, or tax ID number',
  },
  title: {
    id: 'bo_seller_profile_page_tax_details_tab_title',
    defaultMessage: 'Tax details',
  },
  toDoLabel: {
    id: 'bo_seller_profile_page_tax_details_todo_label',
    defaultMessage: 'To do',
  },
  vatMarginSchemeLabel: {
    id: 'bo_seller_profile_page_tax_details_vat_scheme_label',
    defaultMessage: 'VAT scheme',
  },
  vatNumbersByCountryLabel: {
    id: 'bo_seller_profile_page_tax_details_vat_numbers_by_country_label',
    defaultMessage: 'VAT numbers by country',
  },
}
